import { LazyLoad } from "./modules/lazy-load.min.9dc7e6d0.js";
import { Swipers } from "./modules/swipers.min.761030ce.js";
import { JustifiedGallery } from "./modules/justified-gallery.min.2c9f711a.js";

// Components & Pages
import { Header } from "./modules/header.min.b26cfb65.js";
import { Home } from "./modules/home.min.acd90167.js";
import { About } from "./modules/about.min.0e4d124d.js";
import { Products } from "./modules/products.min.135b9521.js";
import { ProductPage } from "./modules/product-page.min.fcce7fa6.js";
import { News } from "./modules/news.min.20153976.js";
import { SingleNews } from "./modules/single-news.min.d5a87997.js";
import { Contacts } from "./modules/contacts.min.39a46cba.js";

// Libraries
import { Filters } from "./modules/filters.min.9e099bea.js";
import { ModelViewer } from "./modules/three.min.8dbb82ce.js";
import { ProductGrid } from "./modules/product-grid.min.9beb3ca7.js";
import { ProductsMobileFilters } from "./modules/products-mobile-filters.min.ea41e926.js";
import { Search } from "./modules/search.min.fa3f9682.js";
import { SubNav } from "./modules/sub-nav.min.d483f245.js";

let appLenis = {};
let isPageLoad = true;
let swup = null;

// Initialize page
function init() {
  // Initialize Gsap + ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Initialize Swup
  swup = new Swup({
    containers: ["#swup", "#site-navbar", ".footer"],
    cache: false,
  });

  // Init scroll monitor
  transitionCallback();

  // Set transition callback
  swup.hooks.on("content:replace", transitionCallback);

  // Reload iubenda iframes
  swup.hooks.on("page:view", function () {
    if ($(".iubenda-embed").length > 0) {
      location.reload();
    }
  });
}

const initLenis = () => {
  appLenis = {
    initialized: false,
    _lenis: null,

    init() {
      this._lenis = new Lenis({
        lerp: 0.085, // default value: 0.1

        // Prevent scrolling over model viewer                                                                                                                                               ▐
        prevent: (node) => node.classList.contains("model-viewer"),
      });

      this.initEvents();
      this.initialized = true;
    },

    initEvents() {
      this._lenis.on("scroll", ScrollTrigger.update);

      gsap.ticker.add((time) => {
        this._lenis.raf(time * 1000);
      });
    },

    destroy() {
      this._lenis.stop();
      this._lenis.destroy();
    },
  };

  appLenis.init();
};

const destroyAnimations = () => {
  const Alltrigger = ScrollTrigger.getAll();
  for (let i = 0; i < Alltrigger.length; i++) {
    Alltrigger[i].kill(true);
  }
};

const initPages = () => {
  new Header(isPageLoad, appLenis);
  new Home(isPageLoad);
  new About(isPageLoad);
  new Products(isPageLoad);
  new ProductPage(isPageLoad, swup);
  new News(isPageLoad);
  new SingleNews(isPageLoad);
  new Contacts(isPageLoad);
};

// Callback called on swup transition
function transitionCallback() {
  // Save libraries for later use
  window.Filters = Filters;
  window.ModelViewer = ModelViewer;
  window.ProductGrid = ProductGrid;
  window.ProductsMobileFilters = ProductsMobileFilters;
  window.Search = Search;
  window.SubNav = SubNav;

  // Destroy prvious animations
  destroyAnimations();

  // Stop lenis to prevent scrolling during transitions
  if (appLenis.initialized) {
    appLenis.destroy();
  }

  // Initialize Lenis
  initLenis();

  // Initialize Pages
  initPages();

  // Initialize swipers
  new Swipers().init();

  // Reinitialize justified gallery
  new JustifiedGallery().init();

  // Reinitialize lazy load
  new LazyLoad().init();

  // Iubenda cleanup
  iubendaCheck();

  // Hide/Show reCaptcha badge based on page
  if ($("#contact-form").length > 0) {
    $(".grecaptcha-badge").addClass("visible");
  } else {
    $(".grecaptcha-badge").removeClass("visible");
  }
}

function iubendaCheck() {
  setTimeout(function () {
    if (_iub.cs.consent.purposes !== undefined) {
      let purposes_iub = Object.keys(_iub.cs.consent.purposes);

      for (let i = 0; i < purposes_iub.length; i++) {
        // Hide cookie message for enabled purposes
        if (_iub.cs.consent.purposes[purposes_iub[i]] == true) {
          $(".content-before-consent-" + purposes_iub[i]).each(
            function (_, el) {
              el.style.display = "none";
            },
          );

          // Send events to GTM
          switch (purposes_iub[i]) {
            case "2":
              // Attivatore Tag Manager categoria Interazioni Semplici
              dataLayer.push({ event: "iubenda-interazioni-semplici" });
              break;
            case "3":
              // Attivatore Tag Manager categoria Esperienza Migliorata
              dataLayer.push({ event: "iubenda-esperienza-migliorata" });
              break;
            case "4":
              // Attivatore Tag Manager categoria Misurazione
              dataLayer.push({ event: "iubenda-misurazione" });
              break;
            case "5":
              // Attivatore Tag Manager categoria Pubblicità
              dataLayer.push({ event: "iubenda-pubblicita" });
              break;
          }
        } else {
          // Show cookie message for disabled purposes
          $(".content-before-consent-" + purposes_iub[i]).each(
            function (_, el) {
              el.style.display = "flex";
            },
          );
        }
      }
    } else {
      // Show cookie message for disabled purposes
      $(".content-before-consent").each(function (_, el) {
        el.style.display = "block";
      });
    }

    // Add callback for "iubenda-cs-preferences-link"
    $(".iubenda-preferences").on("click", function () {
      _iub.cs.api.openPreferences();
    });

    // Activate iubenda snippets
    _iub.cs.api.activateSnippets();
  }, 500);
}

function removePreloader() {
  isPageLoad = false;

  // Remove preloader
  const preloaderBg = document.querySelector("#preloader");
  const preloaderLogo = document.querySelector("#preloader img");
  const delay = 0.5;

  const tl = gsap.timeline();

  tl.to(preloaderLogo, {
    opacity: 0,
    y: "-8rem",
    duration: 1.2,
    delay: delay,
  }).to(preloaderBg, {
    opacity: 0,
    duration: 1,
    delay: -0.25,
    onComplete: () => {
      preloader.remove();
    },
  });
}

// Initialize page
$(function () {
  init();
  removePreloader();
});

function gestisciBrMobile() {
  if (window.innerWidth <= 990) {
    document.querySelectorAll('p br, h1 br, h2 br, h3 br').forEach(br => {
      // Sostituisce il BR con un vero nodo di testo contenente uno spazio
      const spazio = document.createTextNode(' ');
      br.parentNode.replaceChild(spazio, br);
    });
  }
}

// Esegui al caricamento e al ridimensionamento
window.addEventListener('DOMContentLoaded', gestisciBrMobile);

